import { Platform } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

// Mirrors ChooseTimeCalendar/ChooseTimeCalendarDay so the skeleton occupies the
// exact same box as the row it stands in for: same column gap, same flexed
// cells, same circle-to-label gap. Sizes are derived (flex/aspectRatio), never
// hard-coded pixels, so the two stay aligned at every viewport width.
export const styles = StyleSheet.create(() => ({
  daysRow: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    width: '100%',
    columnGap: theme.spacing[4],
  },
  day: {
    flex: 1,
    alignItems: 'center',
  },
  // Stands in for ChooseTimeCalendarDay's indicatorRing: the ring's 2pt padding
  // plus 1pt border is what insets the filled circle inside the cell.
  dayCircle: {
    width: '100%',
    aspectRatio: 1,
    padding: 3,
    maxWidth: {
      base: undefined,
      tablet: 52,
    },
  },
  dayCircleSkeleton: {
    width: '100%',
    height: '100%',
  },
  // The day name renders at a 16pt line height; the bar inside is shorter so it
  // reads as a skeleton without changing the cell's height.
  dayLabel: {
    height: 16,
    justifyContent: 'center',
  },
  openCalendarButtonContainer: {
    flex: 1,
    alignItems: 'center',
    paddingTop: theme.spacing[Platform.OS === 'web' ? 2 : 1],
  },
  openCalendarButton: {
    height: Platform.OS === 'web' ? 40 : 36,
    width: Platform.OS === 'web' ? 40 : 36,
  },
}));
